import {Button} from "@wakelet/ui-kit";
import {FC} from "react";
import {inputClass} from "../form/input-class";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import {FieldGroup, ValidationError} from "../form/ValidationError";
import {translateKey} from "../language/translate";
import {AccountsError} from "../login/useLoginWithEmail";
import {FieldLabel, RequiredFieldsMessage} from "../form/FieldLabel";

type Props = {
  close: () => void
  onSubmit: (values: EmailForm) => Promise<void>
  setIsSuccess: (b: boolean) => void;
  setIsError: (b: boolean) => void;
}

type EmailForm = {
  email: string;
  serverError: void;
}
const enterValidEmailAddressMsg = translateKey("account:validation.email");
const schema = yup.object({
  email: yup.string().required(enterValidEmailAddressMsg).email(enterValidEmailAddressMsg),
})

export const InitResetPassword: FC<Props> = ({close, onSubmit, setIsSuccess, setIsError}) => {
  const {register, handleSubmit, formState: {errors}, setError, clearErrors} = useForm<EmailForm>({
    resolver: yupResolver(schema)
  })

  const doSubmit = async (values: EmailForm) => {
    clearErrors();
    close();
    return onSubmit(values).then(() => {
      setIsSuccess(true);
    }).catch((err: AccountsError) => {
      const {i18nKey} = err;
      setError("serverError", {message: i18nKey.key});
      setIsError(true);
    });
  }

  return <form onSubmit={handleSubmit(doSubmit)} className="pr-1">
    <FieldGroup>
      <FieldLabel htmlFor={"email"}>{translateKey("account:placeholders.email")}</FieldLabel>
      <input
        id="email"
        type="text"
        placeholder={translateKey("account:placeholders.email")}
        className={inputClass()}
        {...register("email")}
        data-testid="email-field"
        aria-required={true}
        aria-describedby={errors.email && "reset-password-email-error"}
        aria-invalid={!!errors.email}/>
      <RequiredFieldsMessage/>
      <ValidationError message={errors.email?.message} id="reset-password-email-error"/>
    </FieldGroup>
    <div className="w-full flex flex-row justify-end mb-3">
      <Button variant="secondary" onClick={close}>
        <Button.Label text={translateKey("common:buttons.cancel")}/>
      </Button>
      <Button className="min-w-fit ml-5" type="submit">
        <Button.Label text={translateKey("common:buttons.confirm")}/>
      </Button>
    </div>
  </form>
};
